import { ENV } from '@configs/env'

export const useDocTitle = ({ location }) => {
    const organization = ENV.APP_NAME
    const pathname = location.pathname

    const segments = pathname.split('/').filter(Boolean);
    const lastSegment = segments.pop();
    const secondLastSegment = segments.pop();

    const formatSegment = (segment) => segment ? segment.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : '';

    let title = organization; 
    if (pathname !== '/') {
        title = lastSegment 
            ? `${formatSegment(lastSegment)} | ${organization}`
            : organization;
        if (secondLastSegment && lastSegment?.match(/\d+$/)) {
            title = `${formatSegment(secondLastSegment)} (${formatSegment(lastSegment)}) | ${organization}`;
        }
    }

    return document.title !== title && (document.title = title);
}